import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  goldReturn: "goldReturn [Action]",
  goldReturnLoading: "goldReturnLoading [Action]",
  goldReturnAsync: "goldReturnAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const goldReturnReducer = (state = inistiaState, { type, payload }) => {
  switch (type) {
    case actionTypes.goldReturn:
      return {
        ...state,
        data: payload,
        total: payload?.total,
      };
    case actionTypes.goldReturnLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.goldReturnLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "GOLD",
    method_type: "gold_return",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }

    yield put({
      type: actionTypes.goldReturn,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.goldReturnLoading,
      payload: false,
    });
  }
}

export function* goldReturn() {
  yield takeLatest(actionTypes.goldReturnAsync, handleWorker);
}
